<template>
	<div class="ui-detail" id="mbBody" ref="mbBody">
		<div class="title"><span class="border"></span><span class="titleinfo">宝贝详情</span><span class="border"></span></div>
		<div>
			<desc-item
				:mbBody="mbBody"
				:detailInfo="detailInfo"
				v-if="detailInfo"
			></desc-item>
		</div>
		<v-back-top v-if="isshowBacktop" :target="target"></v-back-top>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import DescItem from './DescItem'
import BackTop from './DetailBackTop'
export default {
  data () {
    return {
      isshowBacktop: false
    }
  },

  mounted () {


	 window.addEventListener('scroll', this.handleScroll, true)  
  },

  components: {
    'desc-item': DescItem,
    'v-back-top': BackTop
  },

  computed: mapState({
    detailInfo: state => state.goodsdetail.detailInfo,
    mbBody: state => state.goodsdetail.mbBody
  }),

  methods: {
	  handleScroll() {
	  	let mbBodytop = this.$refs.mbBody.getBoundingClientRect().top;
	  	this.$emit('mbBodytop',mbBodytop);
	  },
  }
}
</script>

<style lang="scss" scoped>
.ui-detail{
	margin: .5rem 0;
	min-height: 10rem;
	position: relative;
	.title{
		font-size: .8rem;
		text-align: center;
		padding: 0.3rem 0;
		display: flex;
		align-items: center;
		justify-content: center;
		.border{
			width: 3rem;
			height: 1px;
			background-color: #eee;
			margin: 0 .5rem;
		}
	}
}
</style>
